import MaterialTable from '@material-table/core';
import { CloudDownload, Delete, Description, Message, Print, RecentActors, Visibility } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { tableIcons, tableLocalization } from '../../../@jumbo/constants/TableConstants';
import axios_instance from '../../../services/auth/jwt/config';
import { useParams } from 'react-router';
import ViewInscricao from './ViewInscricao';
import sweetAlert from '../../../f5/utils/sweetAlert';
import ModalFullLSE from '../../../f5/utils/ModalFullLSE';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Document, Page, PDFViewer, Text, View } from '@react-pdf/renderer';
import DeclaracaoPatrimonioPDF from './DeclaracaoPatrimonioPDF';

interface InscricoesFormProps {

}

export default function InscricoesForm({ ...props }: InscricoesFormProps) {
    const [form, setForm] = useState({
        title: '', columns: [],
    })
    const [inscricoes, setInscricoes] = useState<any[]>([])
    const [steps, setSteps] = useState([])
    const [success, setSuccess] = useState({ has: false, message: '' })
    const [loading, setLoading] = useState({ is: true, message: 'Carregando' })
    const [error, setError] = useState({ has: false, message: '' })
    const [askDelete, setAskDelete] = useState({ open: false, id: '', message: '' })
    const [viewing, setViewing] = useState({ open: false, data: {}, user: {}, id: '' })
    const [reply, setReply] = useState({ open: false, id: 0 })
    const [print, setPrint] = useState({ open: false, name: '' })
    const [declaracao, setDeclaracao] = useState<{ open: boolean, data: any }>({ open: false, data: {} })
    const { slug } = useParams<{ slug: string }>()

    useEffect(() => {
        axios_instance.get<{ success: boolean, form: any, inscricoes: any[], steps: any }>(`form/inscricoes/${slug}`).then((response) => {
            let r = response.data
            if (r.success) {
                setForm(r.form)
                setInscricoes(r.inscricoes)
                setSteps(r.steps)
            }
        }).catch(() => {
            sweetAlert('error', 'Erro ao carregar inscrições')
        }).finally(() => {
            setLoading({ is: false, message: '' })
        })
    }, [slug])

    /* const onExport = () => {
        setLoading({ is: true, message: 'Exportando' })
        axios_instance.get(`api/form/inscricoes/${id}/export`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('client_key')}`,
                'Accept': 'application/json'
            },
        }).then(res => res.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                let name = form.title.replace(/ /g, '_')
                a.download = `${name}.xlsx`;
                a.click();
            }).catch(() => {
                setError({ has: true, message: 'Erro ao exportar' })
            }).finally(() => {
                setLoading({ is: false, message: '' })
            })
    } */

    const onDelete = (id: string) => {
        setAskDelete({ open: false, id: '', message: '' })
        axios_instance.post<{ success: boolean, message: string }>(`form/inscricoes/${askDelete.id}/delete`, {}).then((response) => {
            let r = response.data
            if (r.success) {
                setSuccess({ has: true, message: 'Inscrição excluída' })
                setInscricoes(inscricoes.filter((i: any) => i.id !== askDelete.id))
            } else {
                setError({ has: true, message: 'Erro ao excluir inscrição' })
            }
        }).catch(() => {
            setError({ has: true, message: 'Erro ao excluir inscrição' })
        })
    }

    const onDone = () => {
        setSuccess({ has: false, message: '' })
        setLoading({ is: false, message: '' })
        setError({ has: false, message: '' })
        setAskDelete({ open: false, id: '', message: '' })
    }

    return <div className="app-wrapper">
        <MaterialTable
            localization={tableLocalization}
            icons={tableIcons}
            title={loading.is ? loading.message : form.title}
            data={inscricoes}
            columns={form?.columns ?? []}
            actions={[
                {
                    icon: () => <Visibility />,
                    tooltip: 'Visualizar',
                    onClick: (_event, rowData: any) => {
                        setViewing({ open: true, data: rowData.data, user: rowData.user, id: rowData.id })
                    }
                }, /* {
                    icon: () => <CloudDownload />,
                    tooltip: 'Exportar', isFreeAction: true,
                    onClick: () => {
                        onExport()
                    }
                }, {
                    icon: () => <Message />,
                    tooltip: 'Responder',
                    onClick: () => {
                        setReply({ open: true, id: 0 })
                    }

                },*/ {
                    icon: () => <Print />,
                    tooltip: 'Imprimir',
                    onClick: (_event, rowData: any) => {
                        setPrint({ open: true, name: `${rowData.data.nome}` })
                    }
                }, {
                    icon: () => <Description />,
                    tooltip: 'Declaração de Patrimônio',
                    onClick: (_event, rowData: any) => {
                        setDeclaracao({ open: true, data: rowData.data })
                    }
                }, {
                    icon: () => <Delete />,
                    tooltip: 'Excluir',
                    onClick: (_event, rowData: any) => {
                        setAskDelete({ open: true, id: rowData.id, message: 'Deseja excluir esta inscrição?' })
                    }
                },
            ]}
            options={{
                actionsColumnIndex: -1,
                pageSize: 10,
            }}
        />
        <ViewInscricao
            open={viewing.open} onClose={() => setViewing({ open: false, data: {}, user: {}, id: '' })}
            steps={steps} data={viewing.data} user={viewing.user} id={viewing.id}
        />
        <ModalFullLSE
            error={error} success={success} loading={loading}
            onDone={onDone}
        />
        <Dialog open={askDelete.open} onClose={() => setAskDelete({ open: false, id: '', message: '' })} fullWidth maxWidth="sm">
            <DialogTitle>{askDelete.message}</DialogTitle>
            <DialogActions>
                <Box display="flex" justifyContent="space-between" width="100%" padding={2}>
                    <Button variant="outlined" onClick={() => setAskDelete({ open: false, id: '', message: '' })}>
                        Cancelar
                    </Button>
                    <Button variant="contained" color="secondary" onClick={() => onDelete(askDelete.id)}>
                        Sim, excluir
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
        <Dialog open={print.open} onClose={() => setPrint({ open: false, name: '' })} fullWidth maxWidth="lg">
            <DialogTitle>Imprimir inscrição</DialogTitle>
            <DialogContent>
                <PDFViewer style={{ width: '100%', height: '80vh' }}>
                    {/* @ts-ignore */}
                    <Document>
                        {/* @ts-ignore */}
                        <Page size="A4" orientation="landscape" style={{ padding: 0 }}>
                            <View style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                overflow: 'hidden'
                            }}>
                                <Text style={{
                                    textAlign: 'center',
                                    fontSize: 64,
                                    padding: 10
                                }}>{print.name}</Text>
                            </View>
                        </Page>
                    </Document>
                </PDFViewer>
            </DialogContent>
        </Dialog>
        <DeclaracaoPatrimonioPDF
            open={declaracao.open}
            onClose={() => setDeclaracao({ open: false, data: {} })}
            data={declaracao.data}
        />
        {/* <SweetAlert
            show={askDelete.open} warning showCancel
            confirmBtnText="Sim, excluir" confirmBtnBsStyle="danger"
            title="Atenção" cancelBtnText="Cancelar"
            onConfirm={() => {
                onDelete(askDelete.id)
            }}
            onCancel={() => {
                onDone()
            }}
        >
            {askDelete.message}
        </SweetAlert> */}
        {/* <RespostaUsuario
            open={reply.open} onClose={() => setReply({ open: false, id: 0 })}
            onEnd={() => setReply({ open: false, id: 0 })} user={reply.id} link={`api/form/inscricoes/reply`}
        /> */}
    </div>
}